// extracted by mini-css-extract-plugin
export default {"confirmationDialog":"ConfirmationDialog_confirmationDialog__uUsOu"};